export const LEGACY_WEEKLY_ROW_HEIGHT = 54;
export const LEGACY_WEEKLY_BLOCK_HEIGHT = 48;
export const LEGACY_WEEKLY_HEADER_HEIGHT = 64;

export const getLegacyWeeklyRowHeight = (itemCount: number) => Math.max(1, itemCount) * LEGACY_WEEKLY_ROW_HEIGHT;
